import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
                        <div className="example" data-text="We Serve">
                            <h2>Industries</h2>
                        </div>
                        <p className="strong">Our AR/VR app development solutions serve the following industries.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>
                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                    </div>
                                    Healthcare
                                </li>
                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                    </div>
                                    Real Estate
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                    </div>
                                    Gaming
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                    </div>
                                    Ecommerce
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                    </div>
                                    Lifestyle
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>Nothing stops us from developing world-class AR/VR applications that improve
                                    healthcare service experiences. TekRevol comprehensively caters to the requirements
                                    of the healthcare and wellness industry, building technically sound,
                                    experience-focused, and user-centric mixed reality solutions.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol has a holistic, agile development approach. We develop mixed reality
                                    solutions that are not packed with features to help you roam the real estate world
                                    and view unique houses and properties. The real estate industry challenges are
                                    different, requiring a unique course of action.</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>The gaming industry is among the most profitable industries around the globe, but not
                                    everyone can build a perfect AR and VR game. At TekRevol, our development experts
                                    create mobile tools following industry standards: cross-platform to cloud
                                    functionality, stunning graphics, and virtual, realistic experience.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>Ecommerce markets are booming worldwide, helping the masses reap benefits with much
                                    effort. Now you can increase conversion rates through immersive augmented and
                                    virtual reality experiences to help shoppers browse your store and products from
                                    anywhere in real-time.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>A vast market worldwide uses various lifestyle digital products and augmented and
                                    virtual reality applications to enhance the real-world experience for an elevated
                                    lifestyle. We can help you build the proper mixed reality application that enlists
                                    interactive, immersive features and experiences to help businesses define their
                                    lifestyle creatively.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                        Healthcare
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Nothing stops us from developing world-class AR/VR applications that improve
                                            healthcare service experiences. TekRevol comprehensively caters to the
                                            requirements of the healthcare and wellness industry, building technically
                                            sound, experience-focused, and user-centric mixed reality solutions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                        Real Estate
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has a holistic, agile development approach. We develop mixed reality
                                            solutions that are not packed with features to help you roam the real estate
                                            world and view unique houses and properties. The real estate industry
                                            challenges are different, requiring a unique course of action.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                        Gaming
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>The gaming industry is among the most profitable industries around the globe,
                                            but not everyone can build a perfect AR and VR game. At TekRevol, our
                                            development experts create mobile tools following industry standards:
                                            cross-platform to cloud functionality, stunning graphics, and virtual,
                                            realistic experience.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                        Ecommerce
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Ecommerce markets are booming worldwide, helping the masses reap benefits
                                            with much effort. Now you can increase conversion rates through immersive
                                            augmented and virtual reality experiences to help shoppers browse your store
                                            and products from anywhere in real-time.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                        Lifestyle
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>A vast market worldwide uses various lifestyle digital products and augmented
                                            and virtual reality applications to enhance the real-world experience for an
                                            elevated lifestyle. We can help you build the proper mixed reality
                                            application that enlists interactive, immersive features and experiences to
                                            help businesses define their lifestyle creatively.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;